import React from 'react';
import { Heart, Flag } from 'lucide-react';
import { formatDate } from './utils';

export const PostCard = ({ post, onLike, onReport }) => {
  return (
    <div 
      className="p-5 rounded-xl mb-4"
      style={{ background: '#FAF7F3', border: '1px solid #F7F1EE' }}
      data-testid={`post-${post.id}`}
    >
      <div className="flex items-start justify-between mb-3">
        <div>
          <p 
            className="text-sm font-medium"
            style={{ color: post.is_anonymous ? '#A9756B' : '#1A1A2E', fontFamily: 'Jost, sans-serif' }}
          >
            {post.author_name}
          </p>
          <p 
            className="text-xs"
            style={{ color: '#8A8798', fontFamily: 'Jost, sans-serif' }}
          >
            {formatDate(post.created_at)}
          </p>
        </div>
      </div>
      
      <p 
        className="leading-relaxed mb-4"
        style={{ color: '#2E2E42', fontFamily: 'Jost, sans-serif' }}
      >
        {post.content}
      </p>
      
      <div className="flex items-center gap-4">
        <button
          onClick={() => onLike(post.id)}
          className={`flex items-center gap-1.5 text-sm transition-all ${post.user_hearted ? 'scale-105' : 'hover:scale-105'}`}
          style={{ color: post.user_hearted ? '#A9756B' : '#8A8798' }}
          data-testid={`like-post-${post.id}`}
        >
          <Heart className={`w-4 h-4 ${post.user_hearted ? 'fill-current' : ''}`} />
          <span style={{ fontFamily: 'Jost, sans-serif' }}>{post.heart_count || 0}</span>
        </button>
        
        <button
          onClick={() => onReport(post.id)}
          className="text-sm transition-opacity hover:opacity-70"
          style={{ color: '#A3A0AE', fontFamily: 'Jost, sans-serif' }}
          data-testid={`report-post-${post.id}`}
        >
          <Flag className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export const PostList = ({ posts, onLike, onReport }) => {
  if (posts.length === 0) {
    return (
      <div 
        className="text-center py-12"
        style={{ color: '#8A8798', fontFamily: 'Jost, sans-serif' }}
      >
        <p>No reflections yet. Be the first to share.</p>
      </div>
    );
  }
  
  return (
    <div data-testid="posts-list">
      {posts.map((post) => (
        <PostCard 
          key={post.id} 
          post={post} 
          onLike={onLike}
          onReport={onReport}
        />
      ))}
    </div>
  );
};
